export default {
  email: '',
  password: '',
  firstName: '',
  lastName: '',
  companyName: '',
  function: '',
  street: '',
  streetNumber: '',
  city: '',
  postcode: '',
  country: '',
  telNumber: '',
  privacy: false,
  terms: false
};
